import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.QUALITY}` as const;

export const QUALITY_NAMES = {
  FACTORS: 'factors',
  METHODS: 'methods',
} as const;

export interface IQuality {
  [QUALITY_NAMES.FACTORS]: string;
  [QUALITY_NAMES.METHODS]: string;
}

export const qualityInitialValues = {
  [QUALITY_NAMES.FACTORS]: '',
  [QUALITY_NAMES.METHODS]: '',
};
